// opted against using react-bootstrap pagination because of issues with a11y

import React from 'react';
import { connect } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { waitForInvData } from 'wsm-srp-utilities';
import { getSortedPagination } from '../utilities/paging';
import PaginationItem from '../components/PaginationItem';
import PaginationNext from '../components/PaginationNext';
import PaginationPrevious from '../components/PaginationPrevious';
import PaginationEllipsis from '../components/PaginationEllipsis';
import PagingContainer from '../components/PagingContainer';

class WidgetContainer extends React.Component {
	static getShowOffSiteSessionStorage() {
		return (
			(typeof sessionStorage !== 'undefined' &&
				sessionStorage.getItem('showOffSite') &&
				true) ||
			false
		);
	}

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			paging: null,
			showOffSite: WidgetContainer.getShowOffSiteSessionStorage()
		};
		if (isBrowser) {
			waitForInvData(this);
		}
	}

	componentDidMount() {
		if (isBrowser && window.DDC && window.DDC.pubsub) {
			window.DDC.pubsub.subscribe('ws-inv-data/inventory', () => {
				this.setState({
					isLoading: false,
					paging: window.DDC.InvData.getPaging()
				});
			});
			window.DDC.pubsub.subscribe(
				'ws-inv-listing/showOffSiteInventory',
				() => {
					this.setState({
						showOffSite: true
					});
				}
			);
		}
	}

	render() {
		const { isLoading, paging, showOffSite } = this.state;
		if (!isBrowser || !window.DDC.InvData || isLoading) {
			return null;
		}

		const { offSiteData } = window.DDC.InvData.getFacets();

		const isFirstPage = paging && paging.pageStart === 0;
		const offSiteToggleEnabled =
			offSiteData &&
			(offSiteData.offSiteBannerPosition !== -1 ||
				offSiteData.offSiteItemCount !== -1);
		const onSiteInventoryRequiresPaging =
			offSiteData &&
			paging &&
			offSiteData.offSiteBannerPosition >= paging.pageSize - 1;
		const offSiteHidePagingCondition =
			offSiteToggleEnabled &&
			!showOffSite &&
			!onSiteInventoryRequiresPaging &&
			isFirstPage;
		if (
			!paging ||
			paging.totalCount === 0 ||
			paging.totalCount < paging.pageSize ||
			offSiteHidePagingCondition
		) {
			return <PagingContainer />;
		}

		const currentPage = Math.floor(paging.pageStart / paging.pageSize);
		const sorted = getSortedPagination(currentPage, paging);
		const pages = [];

		sorted.forEach((value, i) => {
			pages.push(
				<PaginationItem
					key={value}
					currentPage={currentPage}
					pageIndex={value}
					pageNumber={value + 1}
					pageSize={paging.pageSize}
				/>
			);
			// Add ellipsis when there is a gap between pages
			if (sorted[i + 1] && value + 1 !== sorted[i + 1]) {
				pages.push(<PaginationEllipsis key={`ellipsis-${value}`} />);
			}
		});

		return (
			<PagingContainer>
				<nav aria-label="Navigation for matching results pages">
					<ul className="pagination">
						<PaginationPrevious paging={paging} />
						{pages}
						<PaginationNext paging={paging} />
					</ul>
				</nav>
			</PagingContainer>
		);
	}
}

WidgetContainer.propTypes = {};

const mapStateToProps = _state => {
	return {};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
